import React from 'react';

function Spinner({
  size = 100, isBtn, minWidth = 'max-content', isSearch = false,
}) {
  const strokeWidth = size * 0.1;
  const radius = (size - strokeWidth) / 2;
  const spinnerStyle = {
    animation: 'rotate 1s linear infinite',
  };

  return (
    <div
      className="spinner-container"
      style={{
        // eslint-disable-next-line no-nested-ternary
        height: isBtn ? 'max-content' : isSearch ? '35vh' : '100vh',
        minWidth,
      }}
    >
      <style>
        {`
        @keyframes rotate {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}
      </style>
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        style={spinnerStyle}
      >
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={isBtn ? 'white' : 'rgba(0, 90, 168, 0.2)'}
          strokeWidth={strokeWidth}
        />
        <path
          d={`
            M ${size / 2}, ${strokeWidth / 2}
            A ${radius} ${radius} 0 0 1 ${size / 2 + radius * Math.sin(2 * Math.PI * 0.3)} ${size / 2 - radius * Math.cos(2 * Math.PI * 0.3)}
          `}
          fill="none"
          stroke="#005AA8"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}

export default Spinner;
